import type { ReactNode } from "react";
import { CreatorOfficeLogo } from "../../components/shell/Logo";
import { toggleTheme } from "../../lib/theme";
import "./intern.css";

/**
 * Rahmen der Anmeldeseiten des internen Bereichs (Inhaber 03.11.2026): „CreatorOffice · Intern“, dunkle neutrale Kopfleiste,
 * keine Website-Navigation, keine Registrierung, kein Cookie-Banner und kein Google-Tag (die hängen nur an WebLayout und
 * StartRahmen des Kundenportals), nie indexieren.
 */
export function InternRahmen({ title, children }: { title?: string; children: ReactNode }) {
  return (
    <div className="co-intern">
      <title>{title ? `${title} · CreatorOffice · Intern` : "CreatorOffice · Intern"}</title>
      <meta name="robots" content="noindex, nofollow, noarchive" />
      <a className="skip btn" href="#main">Zum Inhalt</a>
      <header className="co-intern-kopf">
        <span className="co-intern-marke">
          <CreatorOfficeLogo form="symbol" size="sm" />
          <strong>CreatorOffice</strong><span>· Intern</span>
          <span className="co-intern-plakette">Team</span>
        </span>
        <button type="button" onClick={toggleTheme}>Hell / Dunkel</button>
      </header>
      <main id="main" className="co-intern-main">{children}</main>
      <footer className="co-intern-fuss">Interner Zugang für das Team von CreatorOffice. Jede Anmeldung und jeder Zugriff wird protokolliert.</footer>
    </div>
  );
}
